import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "QuestionCircle",
  "use": "QuestionCircle-usage",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" id=\"QuestionCircle\">\n  <path d=\"M11.5 18h2v-2h-2v2Zm1-16c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10Zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol